module.exports = __webpack_public_path__ + "static/img/banner.d5016975.png";